import { NAME_MAX_LENGTH } from "./numbers";

export const ADDRESS_ERROR = "Invalid address";

export const NAME_EMPTY_ERROR = "The name cannot be empty";

export const NAME_LENGTH_ERROR = `The name should not be more than ${NAME_MAX_LENGTH} characters`;

export const DUPLICATE_ERROR = "Duplicate wallet";
